<template>

	<div class="ps_local_delivery">

		<!-- <div class="ps_local_delivery__info">
			<img class="" :src="themeurl + '/images/svg/lorry.svg'" alt="">You are entitled to <strong>FREE</strong> <div class="basket_shipping__wrap">
				<u>Standard Delivery</u>
				<div class="basket_shipping__hover">
					<p class="basket_shipping__title">When will I get my items?</p>
					<p class="basket_shipping__p">On receipt of your order, we will call you within two working days to arrange a suitable time for delivery. Your delivery will be made within 2-5 days. We will always be as flexible as possible. We always strive to deliver a fast, efficient service.</p>
				</div>
			</div>

			<p class="small">Once your order is processed, we will phone you to book a Named Day Delivery slot</p>
		</div> -->

		<p class="ps_local_delivery__itemsheading" v-if="cart_items.length > 0">Optional Delivery Service</p>

		<div class="ps_local_delivery__items">
			<div class="ps_local_delivery__item" v-for="(cart_item, index) in cart_items" :key="cart_item.key">

				<div v-if="cart_item.bag_size == 'Super' || cart_item.bag_size == 'Jumbo'"> 
				
				</div>
				<div class="active" v-else>

					<div class="ps_local_delivery__header">
						<figure class="ps_local_delivery__img">
							<img :src="cart_item.img" :alt="cart_item.name">
						</figure> 

						<p class="ps_local_delivery__name">{{ cart_item.name }}</p>
						<p class="ps_local_delivery__qty">Qty: {{ cart_item.quantity }}</p>
						<p class="ps_local_delivery__toggle_options" :data-index="index">
							<template v-if="!cart_item.hide_options">Hide options</template>
							<template v-if="cart_item.hide_options">Show options</template>
						</p>
					</div>

					<div class="ps_local_delivery__accordion">

						<div class="ps_local_delivery__options">
 
							<div class="ps_local_delivery__option" v-for="(delivery_option, del_index) in cart_item.delivery_options">

								<p v-if="cart_item.all_bags == false" class="ps_local_delivery__bag_number">Bag {{ del_index + 1 }}</p>

								<div class="ps_delivery__option ps_delivery__option--small" @click="checkRadio(index, del_index, 'None')">
									<input type="radio"
										:name="'cart_item-' + index + '-' + del_index + '[]'"
										v-model="delivery_option.delivery_service"
										value="None"
									>
									<div class="ps_delivery__option_label">
										<p class="ps_delivery__title">I don't require additional services</p>
									</div>
								</div>

								<div class="ps_delivery__option" @click="checkRadio(index, del_index, 'Grade 1')">
									<input type="radio"
										:name="'cart_item-' + index + '-' + del_index + '[]'"
										v-model="delivery_option.delivery_service"
										value="Grade 1"
									>
									<div class="ps_delivery__option_label">
										<p class="ps_delivery__title">Grade 1 Delivery - £{{ charges.delivery_service['Grade 1'] }} per bag</p>
										<p class="ps_delivery__price">£{{ totalGrade(cart_item, 'Grade 1') }}</p>

										<p class="ps_delivery__description">The logs will be placed on a set of wheels and taken to your delivery location. <a :href="siteurl + '/delivery-information/#Local-delivery-information'" target="_blank">More information</a></p>
									</div>
								</div>

							</div>

						</div>

						<div class="ps_local_delivery__checkbox ps_local_delivery__checkbox--all" v-if="cart_item.quantity > 1">
							<input type="checkbox" :id="'apply_to_all-' + index" v-model="cart_item.all_bags" @change="applyIndividual(cart_item)">
							<label :for="'apply_to_all-' + index">Add delivery service to all bags of this product</label>
						</div>

					</div>
				</div>
			</div>
		</div>

		<div v-if="cart_items.length > 0">
			<div class="firewood_prod__btn_wrap ps_local_delivery__loader" :class="{'firewood_prod__btn_wrap--loading': loading}">
				<img class="lorry" src="/wp-content/themes/logshed/images/svg/lorry.svg" alt=""><p class="ps_local_delivery__update" @click="updateDeliveryCosts()">Update Delivery Service Costs</p>
 
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(50,50)"><g transform="scale(0.7)"><circle cx="0" cy="0" r="50" fill="#e75000"></circle><circle cx="0" cy="-19" r="15" fill="#ffffff"><animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 0 0;360 0 0"></animateTransform></circle></g></g></svg>
			</div>
		</div>

		<span class="woo_btn--checkout" @click="updateDeliveryCosts(true)">Proceed to secure checkout</span>

	</div>

</template>

<script>
	const axios = require('axios');

	export default {
		data: function() {
			return {
				cart_items: [],
				selected: [],
				charges: {
					delivery_service: {
						'Grade 1': 10,
						'Grade 2': 20,
						'Grade 3': 40,
					},
					stacking: {
						'Dumpy': 20,
						'Barrow': 5,
					}
				},
				loading: false,
				themeurl: WPURLS['template_directory'],
				siteurl: WPURLS['siteurl'],
			}
		},
		watch: {
			cart_items: {
		      handler(val){
		        // this.updateDeliveryCosts();
		      },
		      deep: true
		   }
		},
		computed: {

		},
		created() {

			jQuery(document.body).on('updated_checkout', () => {
				this.init();
			});

			var sliding = false;

			jQuery('body').on('click', '.ps_local_delivery__toggle_options', (e) => {
				if (!sliding) {
					sliding = true;
					var accordion = jQuery(e.target).parents('.ps_local_delivery__item').find('.ps_local_delivery__accordion');
					var index = jQuery(e.target).data('index');

					jQuery(accordion).slideToggle(300, () => {
						sliding = false;
						this.cart_items[index].hide_options = !this.cart_items[index].hide_options;
					});
				}
			});

		},
		methods: {
			init() {
				var all = [];
				var get_cart_items = jQuery('.cart_item');

				for (var i = 0; i < get_cart_items.length; i++) {
					var data = jQuery(get_cart_items[i]).data('local_delivery');

					if (data !== '') {
						if (data.delivery_options.length > 1) {
							data.all_bags = false;
						} else {
							data.all_bags = true;
						}
						all.push(data);
					}
				}

				this.cart_items = all;
			},
			checkRadio(index, del_index, value) {
				this.cart_items[index].delivery_options[del_index].delivery_service = value;

				if (value == 'None') {
					this.cart_items[index].delivery_options[del_index].stacking = false;
				}
				// console.log(this.cart_items[index].delivery_options[del_index]);
				this.updateDeliveryCosts(false);
			},
			applyIndividual(cart_item) {
				if (cart_item.all_bags == false) {
					var adding = cart_item.quantity - cart_item.delivery_options.length;
					var temp = {};
					temp['delivery_service'] = '';
					temp['stacking'] = '';

					for (var i = 0; i < adding; i++) {
						cart_item.delivery_options.push(temp);
					}
				} else {
					cart_item.delivery_options.splice(1, cart_item.delivery_options.length);
				}

				this.updateDeliveryCosts(false);
			},
			totalGrade(cart_item, grade) {
				var cost = this.charges.delivery_service[grade];

				if (cart_item.all_bags) {
					return cost * cart_item.quantity;
				}

				return cost;
			},
			updateDeliveryCosts(checkout = false) {
				// Start loading effect
				this.loading = true;

				var data = {
					cart_items: this.cart_items,
				};

				const params = new URLSearchParams();
				params.append('action', 'aj_ajax_update_delivery');
				params.append('data', JSON.stringify(data));

				axios.post(WPURLS.ajaxurl, params)
					.then((response) => {

						if (checkout) {
							jQuery('#confirm-order-flag').val('');
							jQuery('#place_order').trigger('click');
						} else {
							jQuery(document.body).trigger('update_checkout');
						}

					})
					.catch((error) => {
						// handle error
						console.log(error);
					})
					.then(() => {
						this.loading = false;
					});

			},
			checkout() {

			}
		}
	}
</script>
